import { RepositoryFactory } from '@/api/repositoryFactory';
import { IDiscussDomain, IDomain } from '@/models/domain.model';
import { PersistentStore } from './main';
import { i18n } from '@/global_initApp';

interface DomainStoreModel extends Object {
  domainid: number | null;
  domain: IDomain | null;
  discuss: IDiscussDomain | null;
  language: string;
  project_thought_term: string;
}

class DomainStore extends PersistentStore<DomainStoreModel> {
  protected data(): DomainStoreModel {
    return {
      domainid: null,
      domain: null,
      discuss: null,
      language: 'de',
      project_thought_term: '',
    };
  }
  private setDiscuss(discuss: IDiscussDomain) {
    this.state.discuss = discuss;
  }
  private unsetDiscuss() {
    this.state.discuss = null;
  }
  private setDomain(domain: IDomain) {
    this.state.domain = domain;
  }
  private unsetDomain() {
    this.state.domain = null;
  }
  updateLanguage(project_thought_term: string, lang = '') {
    if (lang) {
      this.state.language = lang;
    }
    this.state.project_thought_term = project_thought_term;
    if (this.state.project_thought_term) {
      i18n.global.locale.value = this.state.language + '-' + this.state.project_thought_term;
    } else {
      i18n.global.locale.value = this.state.language;
    }
  }
  translate(value: string) {
    // without explicitly resetting locale here, translations won't persist when hiding/reloading content
    if (this.state.project_thought_term) {
      i18n.global.locale.value = this.state.language + '-' + this.state.project_thought_term;
    } else {
      i18n.global.locale.value = this.state.language;
    }
    return i18n.global.t(value);
  }
  setDomainId(domainid: number) {
    this.state.domainid = domainid;

    this.fetchDomainConfig();
    // this.fetchDiscussConfig();
  }
  fetchDiscussConfig() {
    const DomainRepository = RepositoryFactory.get('domain');
    // if discuss config was already fetched, simply return
    if (this.state.discuss !== null && this.state.discuss.id == this.state.domainid) {
      return;
    }

    // if domainid got set, but discuss config is not yet fetched, fetch it
    if (this.state.domainid) {
      DomainRepository.getDiscussConfig()
        .then((response: any) => {
          if (response) {
            this.setDiscuss(response);
          } else {
            console.log('error');
          }
        })
        .catch((error: any) => {
          console.log(error);
        });
    } else {
      // if we domainid is not set, unset Discuss data in store
      this.unsetDiscuss();
    }
  }
  fetchDomainConfig() {
    const DomainRepository = RepositoryFactory.get('domain');
    // if domain was already fetched, simply return
    if (this.state.domain !== null && this.state.domain.id == this.state.domainid) {
      return this.state.domain;
    }

    // if domainid got set, but domain config is not yet fetched, fetch it
    if (this.state.domainid) {
      DomainRepository.getDomainConfig()
        .then((response: any) => {
          if (response) {
            this.setDomain(response);
          } else {
            console.log('error');
          }
        })
        .catch((error: any) => {
          console.error(error);
        });
    } else {
      // if we domainid is not set, unset Domain data in store
      this.unsetDomain();
    }
  }
}
export const domainStore = new DomainStore('DOMAIN_STORE');
